import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'IsNumber',
})
export class IsNumberPipe implements PipeTransform {
  transform(value: any): any {
    const temp = +value;

    if (isNaN(temp)) {
      return value;
    } else {
      return temp;
    }
  }
}

export function IsNumber(value: any) {
  if (value == null) return;
  const temp = +value;
  if (isNaN(temp)) {
    return value;
  } else {
    return temp;
  }
}
